var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  @media (min-width: 992px) {\n    max-width: 100%;\n  }\n'], ['\n  padding: 0;\n  @media (min-width: 992px) {\n    max-width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  width: 100%;\n  box-shadow: 0 5px 5px -3px grey;\n'], ['\n  background-color: ', ';\n  width: 100%;\n  box-shadow: 0 5px 5px -3px grey;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 53px;\n  @media (min-width: 992px) {\n    min-height: 80px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 53px;\n  @media (min-width: 992px) {\n    min-height: 80px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 38px;\n  object-fit: contain;\n  margin-left: 10px;\n\n  @media (min-width: 992px) {\n    width: 110px;\n    height: 55px;\n  }\n'], ['\n  width: 50px;\n  height: 38px;\n  object-fit: contain;\n  margin-left: 10px;\n\n  @media (min-width: 992px) {\n    width: 110px;\n    height: 55px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from 'reactstrap';
import { primary } from '../../assets/colors';
import PGALogo from '../../assets/pga-logo.svg';

var HeaderContainer = styled(Container)(_templateObject);
var HeaderFrame = styled.header(_templateObject2, function (props) {
  return props.bkgColor;
});

var Content = styled.div(_templateObject3);

var LogoFrame = styled.img(_templateObject4);

var Header = function Header(_ref) {
  var _ref$logo = _ref.logo,
      logo = _ref$logo === undefined ? PGALogo : _ref$logo,
      _ref$logoLink = _ref.logoLink,
      logoLink = _ref$logoLink === undefined ? '/' : _ref$logoLink,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? primary : _ref$bgColor,
      children = _ref.children;
  return React.createElement(
    HeaderFrame,
    { bkgColor: bgColor },
    React.createElement(
      HeaderContainer,
      null,
      React.createElement(
        Content,
        null,
        React.createElement(
          'a',
          { href: logoLink },
          React.createElement(LogoFrame, { src: logo, alt: 'PGA of America', title: 'PGA of America' })
        ),
        children
      )
    )
  );
};

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  logo: PropTypes.string,
  logoLink: PropTypes.string.isRequired,
  bgColor: PropTypes.string
} : {};

export default Header;